// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.check-header {
  position: relative;
    height: 320px;
    width: 100%;
}

.check-border-not {
    width: 100%;
    border: 1px solid #000;
    border-radius: 10px;
    height: 240px;
}

.company-wrapper {
    position: absolute;
    font-size: 95%;
}

.bank-wrapper {
    position: absolute;
    font-size: 95%;
}

.check-number {
    position: absolute;
    font-size: 120%;
}

.check-date {
    position: absolute;
    /*top: 75px;*/
    /*right:0px;*/
    text-align: right;
}

.check-amount {
  position: absolute;
  /*top: 75px;*/
  /*right:0px;*/
  text-align: right;
}

.stub {
    width: 100%;
    white-space: nowrap;
    height: 330px;
    overflow: hidden;
}

.check-stub-table {
    font-size: 70%;
    width: 24%;
    float: left;
    margin-right: 5px;
    font-weight: normal;
}

.check-stub-table th {
  /*border-bottom: 2px solid #000;*/
    padding: 2px;
}

.check-stub-table-no-border th {
  /*border-bottom: 2px solid #000;*/
  padding: 2px;
}

.check-stub-table td {
  /*border-bottom: 1px solid #000;*/
    padding: 1px;
}

.micr {
    position: absolute;
    width: 100%;
    text-align: center;
    padding-bottom: 42px;
    bottom: 0px;
    left: 0px;
}

.micr img {
    height: 12px;
    margin: 0px 1px;
}

.signature-line {
    position: absolute;
    bottom: 20px;
    right: 60px;
    /*white-space: nowrap;*/
  padding-right: 20px;
  text-decoration: overline;
  font-size: 90%;
}

.pay {
    position: absolute;
    /*top: 120px;*/
    left: 0px;
    white-space: nowrap;
    font-size: 90%;
}

.amount-text {
    position: absolute;
    /*top: 110px;
    left:40px;*/
    white-space: nowrap;
    font-size: 90%;
}

.to-order {
    position: absolute;
    top: 140px;
    left: 0px;
}

.payee {
    position: absolute;
}

.spacer-row td {
  border: none; /* prevents a faint line if table has borders */
  padding: 6px 0; /* tweak spacing as desired */
  line-height: 6px; /* helps keep printed height predictable */
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
